import React from 'react';
import type { Header } from '@tanstack/react-table';

interface ColumnResizeHandleProps<TData> {
  header: Header<TData, unknown>;
  isResizing?: boolean;
}

export default function ColumnResizeHandle<TData>({
  header,
  isResizing = false
}: ColumnResizeHandleProps<TData>) {
  if (!header.column.getCanResize()) {
    return null;
  }

  return (
    <div
      onMouseDown={header.getResizeHandler()}
      onTouchStart={header.getResizeHandler()}
      className={`
        absolute -right-2 top-0 h-full w-4 cursor-col-resize select-none touch-none
        ${isResizing ? 'bg-blue-500 opacity-100' : 'bg-gray-100 opacity-70 hover:opacity-100'}
        transition-opacity
      `}
      data-testid={`resize-handle-${header.column.id}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="absolute left-1/2 top-0 h-full w-0.5 -translate-x-1/2 bg-gray-400" />
    </div>
  );
}
